import { useState } from 'react';
import nike from '../../../../assets/logos/nike.png';

const Settings = () => {
  const pages = ['Profile Settings', 'Team', 'Email Notifications'];
  const [selectedPage, setSelectedPage] = useState(pages[0]);

  function pageHandler(page) {
    switch (page) {
      case 'Profile Settings':
        return <ProfileSettings />;
      case 'Team':
        return (
          <>
            <Team />
            <Team />
            <Team />
          </>
        );
      case 'Email Notifications':
        return <></>;
    }
  }
  return (
    <div className="pb-5 bg-lightblue">
      <div className="bg-lightblue py-3 px-5 border grid grid-cols-2">
        <div className="flex space-x-3">
          {pages.map((el) => (
            <a
              className={`${selectedPage === el ? 'font-semibold' : ''}`}
              onClick={() => setSelectedPage(el)}
              href="#"
            >
              {el}
            </a>
          ))}
        </div>
        <p>
          Filters <i className="fa-solid fa-filter"></i>
        </p>
      </div>
      <div className="w-[270px] flex flex-col items-center py-10 mx-10 space-y-3 h-screen">
        {pageHandler(selectedPage)}
        {selectedPage === 'Team' && (
          <div className="ml-8 w-[350px]">
            <div className="flex items-center space-x-3">
              <img className="w-10 h-10" src={nike} alt="Brand Logo" />
              <input
                type="email"
                className="bg-white border border-neutral-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-[350px] p-2"
                placeholder="Email Id"
                required
              />
              <select className="bg-white border-neutral-300 p-2">
                <option>Editor</option>
                <option>User</option>
              </select>
              <button class="text-white bg-darkblue hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm w-full px-5 py-2 text-center">
                Invite
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const ProfileSettings = () => {
  return (
    <>
      <img className="aspect-auto" src={nike} alt="Brand Logo" />
      <div>
        <label htmlFor="name" className="text-sm">
          Name
        </label>
        <input
          type="text"
          className="bg-white border border-neutral-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-[270px] p-2"
          placeholder="Nike"
          required
        />
      </div>
      <div>
        <label htmlFor="email" className="text-sm">
          Email
        </label>
        <input
          type="email"
          className="bg-white border border-neutral-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-[270px] p-2"
          placeholder="hello@nike.com"
          required
        />
      </div>
      <div>
        <label htmlFor="password" className="text-sm">
          Password
        </label>
        <input
          type="password"
          className="bg-white border border-neutral-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-[270px] p-2"
          placeholder="New Password"
          required
        />
      </div>
      <button class="text-white bg-darkblue hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm w-full px-5 py-2 text-center">
        Save
      </button>
    </>
  );
};

const Team = () => {
  return (
    <div className="flex items-center space-x-3 ml-14">
      <img className="w-10 h-10" src={nike} alt="Brand Logo" />
      <input
        type="email"
        className="bg-white border border-neutral-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-[270px] p-2"
        placeholder="hello@postager.com"
        required
      />
      <select className="bg-white border-neutral-300 p-2">
        <option>Admin</option>
        <option>User</option>
      </select>
    </div>
  );
};

export default Settings;
